// extracted by mini-css-extract-plugin
module.exports = {"shortcut":"Shortcut-styles-module--shortcut--hC7_K text-monospace"};